exports.components = {
  "component---src-pages-404-ts": () => import("./../../../src/pages/404.ts" /* webpackChunkName: "component---src-pages-404-ts" */),
  "component---src-templates-default-plasmic-page-tsx": () => import("./../../../src/templates/defaultPlasmicPage.tsx" /* webpackChunkName: "component---src-templates-default-plasmic-page-tsx" */)
}

